import { cn } from "@/lib/cn";
import { env } from "@/env";

export function Logo({
  className,
  showName = true,
  nameClassName,
}: {
  className?: string;
  showName?: boolean;
  nameClassName?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 leading-none font-semibold whitespace-nowrap",
        className,
      )}
    >
      <svg
        aria-hidden
        className="h-7 w-7 shrink-0"
        fill="none"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="var(--color-brand)" height="32" rx="9" width="32" />
        <path
          d="M7 12.5A2.5 2.5 0 0 1 9.5 10h8a2.5 2.5 0 0 1 2.5 2.5v7a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 7 19.5v-7Z"
          fill="var(--color-brand-ink)"
        />
        <path d="m21 14.5 4-2.6v8.2l-4-2.6v-3Z" fill="var(--color-brand-ink)" />
      </svg>
      {showName ? <span className={nameClassName}>{env.appName}</span> : null}
    </span>
  );
}
